import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Booking, BookingStatus } from 'happypaws-shared/src/Booking/models/Booking';
import { api } from '../../services/api';

export const useUpdateBookingStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bookingId, status }: { bookingId: string; status: BookingStatus }) => {
      const response = await api.patch<Booking>(`/bookings/${bookingId}/status`, { status });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientBookings'] });
      queryClient.invalidateQueries({ queryKey: ['sitterBookings'] });
    },
  });
};
